export enum sdks {
  SETTINGS = 'settings',
  TRACKER = 'tracker',
}

export const pulseScriptAppName = 'picsart.com';

export const sdkScriptDefaultSettings = {
  sdks: [sdks.SETTINGS, sdks.TRACKER],
};

export default { pulseScriptAppName, sdkScriptDefaultSettings };
